import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import "../../assets/styles/admin.css";
import Loader from "../loader/loader";
import ListDatatable from "./listdatatable";

const DepositBlacklist = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchItems = async (currentPage = 1) => {
    setLoading(true);
    try {
      const response = await adminInstance().post(
        "/api/admin/getAllItemsForDepositBlacklist",
        {
          gameId: "252490",
          page: currentPage,
          limit: 100, 
        },
      );
      const { code, items } = response.data;
      if (code === 200) {
        setData(items);
      } else {
        toast.error("Failed to fetch items");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error fetching items");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const refreshData = () => {
    fetchItems(1);
  };

  return (
    <Fragment>
      <Breadcrumb title="Deposit Blacklist" parent="deposit-blacklist" />
      <Container fluid={true} className="index-page">
        <div className="admin-card">
          <Card>
            <CardHeader>
              <h5>Rust Items Deposit Blacklist</h5>
            </CardHeader>
            <CardBody>
              <div className="clearfix"></div>
              <div
                id="batchDelete"
                className="category-table user-list order-table coupon-list-delete">
                {!loading ? (
                  data && data.length > 0 ? (
                    <ListDatatable
                      myData={data}
                      pageSize={10}
                      pagination={true}
                      class="-striped -highlight"
                      refreshData={refreshData}
                    />
                  ) : (
                    <h1>No items found</h1>
                  )
                ) : (
                  <Loader />
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>
    </Fragment>
  );
};

export default DepositBlacklist;
